
import React from 'react';
import { MenuItem } from '../types';

const CATEGORY_TEXT_COLOR: Record<MenuItem['category'], string> = {
  DOCUMENTS: 'text-blue-600',
  ERP: 'text-amber-600',
  SERVICE: 'text-emerald-600',
  ADMIN: 'text-rose-600',
};
const toHref = (raw: string, external?: boolean) => {
  if (external) return raw;
  if (/^https?:\/\//i.test(raw)) return raw;
  return raw;
};

// Map color classes to light background tints
const getBgTint = (colorClass?: string) => {
  if (!colorClass) return 'bg-slate-50';
  const color = colorClass.split('-')[1]; // e.g., 'emerald' from 'text-emerald-500'
  return `bg-${color}-50/50`;
};

export const MenuCard: React.FC<{ item: MenuItem; badgeCount?: number }> = ({ item, badgeCount }) => {
  const href = toHref(item.href, item.external);
  const bgTint = getBgTint(item.color);

  return (
    <a
      href={href}
      target={item.external ? '_blank' : undefined}
      rel={item.external ? 'noreferrer' : undefined}
      className="group relative flex flex-col p-6 bg-white rounded-[2.5rem] border border-slate-100 hover:border-emerald-200 shadow-sm hover:shadow-xl hover:shadow-emerald-500/5 transition-all duration-500 hover:-translate-y-1.5"
    >
      {/* Badge / Sticker - Top Right of Card */}
      {badgeCount && badgeCount > 0 ? (
        <div className="absolute top-5 right-5 z-20 flex h-6 min-w-[24px] items-center justify-center rounded-full bg-rose-500 px-1.5 text-[11px] font-extrabold text-white shadow-lg shadow-rose-500/40 border-2 border-white animate-in zoom-in slide-in-from-top-1 duration-500">
          <span className="relative flex h-2 w-2 mr-1">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
          </span>
          {badgeCount > 99 ? '99+' : badgeCount}
        </div>
      ) : null}

      <div className="absolute top-0 right-0 p-8 text-slate-50 opacity-[0.03] group-hover:opacity-[0.1] transition-opacity">
        <i className={`fas ${item.icon} text-5xl -rotate-12 ${item.color || ''}`}></i>
      </div>

      <div className="relative z-10 flex flex-col h-full">
        <div className="flex items-start justify-between mb-5">
          <div className={`w-12 h-12 flex items-center justify-center rounded-2xl ${bgTint} ${item.color || 'text-slate-400'} group-hover:bg-slate-900 group-hover:text-white transition-all duration-500 shadow-sm border border-white`}>
            <i className={`fas ${item.icon} text-xl group-hover:scale-110 transition-transform duration-500`}></i>
          </div>

          <div className="w-9 h-9 rounded-full bg-slate-50 border border-slate-100 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 -translate-x-2 group-hover:translate-x-0">
            <i className="fas fa-arrow-right text-emerald-500 text-xs"></i>
          </div>
        </div>

        <div className="mt-auto">
          <h3 className="text-base font-bold text-slate-800 mb-1 group-hover:text-emerald-600 transition-colors">{item.label}</h3>
          <p className="text-slate-400 text-sm leading-relaxed mb-3 line-clamp-2 font-medium">{item.description || "Hệ thống quản lý nội bộ"}</p>
          
          <div className="flex items-center justify-between border-t border-slate-50 pt-3">
          <span
  className={[
    'text-[9px] font-black uppercase tracking-[0.2em]',
    CATEGORY_TEXT_COLOR[item.category],
  ].join(' ')}
>
  {String(item.category).replace('_', ' ')}
</span>
          </div>
        </div>
      </div>
    </a>
  );
};
